module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "venue-title-bar",
    style: (_vm.pageTitleBar)
  }, [_c('div', {
    staticClass: "country-flag"
  }, [_c('img', {
    attrs: {
      "src": _vm.countryFlag,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "venue-title"
  }, [_vm._v("\n      " + _vm._s(_vm.venueDisplayName) + " - " + _vm._s(_vm.venueDate) + "\n    ")]), _vm._v(" "), (_vm.uploadedImageName) ? _c('div', {
    staticClass: "venue-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.uploadedImagePath,
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "the-time"
  }, [_vm._v("\n      " + _vm._s(_vm.theTime) + "\n    ")])]), _vm._v(" "), _c('Ticker'), _vm._v(" "), _c('div', {
    staticClass: "flex-race-container"
  }, _vm._l((_vm.screenData[0].races), function(race) {
    return _c('div', {
      key: race.index,
      class: {
        'venue-two-races': _vm.screenData[0].races.length === 2,
          'venue-more-than-two-races': _vm.screenData[0].races.length > 2,
      }
    }, [_c('div', {
      staticClass: "race-title-bar",
      style: (_vm.raceTitleBar)
    }, [_c('div', {
      staticClass: "race-name"
    }, [_vm._v("\n          " + _vm._s(_vm._f("race")(race.fn)) + " - " + _vm._s(_vm._f("satime")(race.raceDateTime)) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "race-titles"
    }, [_c('div', {
      staticClass: "place-title"
    }, [_vm._v("\n            PLACE\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "prev-title"
    }, [_vm._v("\n            PREV\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "price-title"
    }, [_vm._v("\n            PRICE\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "race-places-paid"
    }, [_vm._v("\n            " + _vm._s(race.placesPaid) + " PLACES PAID (" + _vm._s(race.placePercentage) + "%)\n          ")])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), _c('div', {
      staticClass: "markets-container"
    }, [_vm._l((race.markets), function(market) {
      return [(market.marketId) ? [(market.include) ? _c('Market', {
        key: market.id,
        attrs: {
          "places-paid": race.placesPaid,
          "place-percentage": race.placePercentage,
          "venue-id": _vm.screenData[0].venueId,
          "race-id": race.raceId,
          "market-id": market.marketId,
          "venue-index": 1
        }
      }) : _vm._e()] : _vm._e()]
    }), _vm._v(" "), _c('Market', {
      attrs: {
        "scroll-markets": race.scrollMarkets,
        "places-paid": race.placesPaid,
        "place-percentage": race.placePercentage,
        "venue-id": _vm.screenData[0].venueId,
        "race-id": race.raceId,
        "venue-index": 1
      }
    })], 2)])
  }), 0)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e847c77","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Venue.vue
// module id = 230
// module chunks = 1